module.exports = __webpack_public_path__ + "img/BU-Logo.26b28a3c.svg";